import { render, staticRenderFns } from "./TgLimitBetDialog.vue?vue&type=template&id=3fb85c4f"
import script from "./TgLimitBetDialog.vue?vue&type=script&lang=js"
export * from "./TgLimitBetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports